import api from "./api"

/**
 * User Model
 */

export type UserTheme = "light" | "dark"
export interface IUserModel {
    id:number,
    status: string,
    full_name: string,
    email: string,
    first_name: string,
    last_name: string,
    is_staff: boolean,
    is_superuser: boolean,
    thumbnail: string,
    date_joined: string | null,
    type: string,
    is_blocked: boolean,
    is_password_set: boolean,
    totp_enabled: boolean,
    last_login: string,
    is_banned: boolean,
    is_daemon?: boolean,
    theme: UserTheme,
}

export const EmptyUserModel: IUserModel = {
    id: 0,
    status: "",
    full_name: "",
    email: "",
    first_name: "",
    last_name: "",
    is_staff: false,
    is_superuser: false,
    thumbnail: "",
    date_joined: "",
    type: "",
    is_blocked: false,
    is_password_set: false,
    totp_enabled: false,
    last_login: "",
    is_banned: false,
    theme: "light"
}

/**
 * Get current user data
 */
const getCurrentUserData = async() => {
    const response = await api.get('/users/account')
    return response.data
}

/**
 * Update current user
 */
const updateCurrentUser = async(first_name: string, last_name: string, email: string, thumbnail: string) => {
    const response = await api.post('/users/account', { first_name, last_name, email, thumbnail })
    return response
}

/**
 * Update current user password
 */
const updateCurrentUserPassword = async(password: string) => {
    const response = await api.post('/users/account/update-password', { password })
    return response
}

/**
 * Reuest new set-password link
 */
const requestNewPasswordSetLink = async(email: string) => {
    const response = await api.post('/users/set-password/new', { email: email  })
    return response
}

/**
 * Set new password
 */
const setNewPassword = async(email: string, password: string, password_set_unique_id: string) => {
    const response = await api.post('/users/set-password', { email, password, password_set_unique_id  })
    return response
}

/**
 * Reuest forgot password link
 */
const requestForgotPassword = async(email: string, unblock_account?: boolean) => {
    const response = await api.post('/users/account/reset-password/new', { email: email, unblock_account  })
    return response
}

/**
 * Reset password
 */
const resetPassword = async(email: string, password: string, password_set_unique_id: string, unblock_account?: boolean) => {
    const response = await api.post('/users/account/reset-password', { email, password, password_set_unique_id, unblock_account  })
    return response
}

/**
 * Block account
 */
const blockAccount = async(email: string, password: string) => {
    const response = await api.post('/users/account/block', { email, password  })
    return response
}

/**
 * Block user
 */
const blockUser = async(userId: number, unblock?: boolean) => {
    const response = await api.post(`/users/accounts/${userId}/block`, { unblock  })
    return response
}

/**
 * Block user
 */
const banUser = async(userId: number, unban?: boolean) => {
    const response = await api.post(`/users/accounts/${userId}/ban`, { unban  })
    return response
}

const UserService = {
    getCurrentUserData,
    updateCurrentUser,
    updateCurrentUserPassword,
    requestNewPasswordSetLink,
    setNewPassword,
    requestForgotPassword,
    resetPassword,
    blockAccount,
    blockUser,
    banUser
}
export default UserService